module.exports = __webpack_public_path__ + "static/logo_yellow-14ca63d13b50d15537a5059558ce943a.png";